import React, { lazy } from 'react';
import IconException from '@/assets/images/menu/icon-exception.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const cupRoutes = (cpuEnable: boolean): IRouteConfig[] => [
  {
    path: '/cpu',
    name: 'CPU监控',
    icon: <MenuIcon icon={IconException} />,
    hideInMenu: true,
    platforms: [
      CapitalPlatform.Windows,
    ],
    routes: [
      {
        path: '/cpu/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/cpu/analytics')),
      },
      {
        path: '/cpu/list',
        name: '问题列表',
        hideInMenu: !cpuEnable,
        disabled: !cpuEnable,
        component: lazy(() => import('@/presentation/pages/cpu/list')),
      },
      {
        path: '/cpu/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/cpu/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/cpu/drill-down',
        name: '用户分析',
        hideInMenu: !cpuEnable,
        disabled: !cpuEnable,
        component: lazy(() => import('@/presentation/pages/cpu/drill-down')),
      },
    ],
  },
];
